import { render, staticRenderFns } from "./org-edit.vue?vue&type=template&id=1d7d29d5&scoped=true&"
import script from "./org-edit.vue?vue&type=script&lang=js&"
export * from "./org-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7d29d5",
  null
  
)

export default component.exports